import { css } from 'styled-components';
import * as colors from '../../colors';
export const ModalTitle = css `
  /* font-size: 15px;
  color: ${colors.FONT_THIRD};
  text-transform: uppercase;
  font-weight: bold;
  text-align: center;
  border-bottom: 1px solid #eee;
  padding: 16px 0px;
  letter-spacing: 1px;

  text-align: left;
  color: ${colors.FONT_SECONDARY};
  text-transform: capitalize;
  letter-spacing: 0;
  padding: 18px 23px;
  font-size: 15px;
  color: #666; */

  font-size: 15px;
  color: ${colors.FONT_THIRD};
  text-transform: uppercase;
  font-weight: bold;
  /* margin-bottom: 16px; */
  padding: 16px 23px;
  border-bottom: 1px solid #eee;
  text-align: center;
`;
export const ModalFooterStyle = css `
  padding: 13px 20px;
  text-align: right;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  background-color: #f4f4f4;
  border-top: 1.4px solid #eeeeee;
`;
